import styles from './loginform.module.css';
import { FormEvent, useCallback, useEffect } from 'react';
import { ILoginFormStore, LoginInputKeys } from '../../models/types';
import { Input } from '../../../../shared/ui/Input/Input';
import { useUnit } from 'effector-react';
import { Spinner } from '../../../../shared/ui/Spinner/Spinner';
import { Button } from '../../../../shared/ui/Button/Button';
import { INPUTS_ARR, LOGIN_VALIDATION_SCHEMA } from '../../models/consts';
import { checkValidate } from '../../../../shared/lib/input/checkValidate';
import { LoginLinks } from '../LoginLinks/LoginLinks';
import {
	changePasswordInputType,
	login,
	setInputValue,
	setLoginFormStore
} from '../../models/events';
import {
	$loginFormStore,
	$shouldRedirect,
	isPending,
} from '../../models/store';


export function LoginForm() {
    const {
		loginFromStore,
		isLoading,
		shouldRedirect
	} = useUnit({
		loginFromStore: $loginFormStore,
		isLoading: isPending,
		shouldRedirect: $shouldRedirect,
	});

	useEffect(() => {
		if (!shouldRedirect) return;

		const baseUrl = process.env.REACT_APP_BASE_URL || '/';
		window.location.replace(baseUrl);
	}, [shouldRedirect]);

    const handleChangeInput = useCallback((key: keyof ILoginFormStore, value: string) => {
        setInputValue({ key, value });
    }, [])

	const changeInputType = useCallback((
		type: React.HTMLInputTypeAttribute,
		key: keyof ILoginFormStore,
	) => {
		changePasswordInputType({ type: type === 'password' ? 'text' : 'password', key });
	}, [])

	async function handleSubmit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();

		if (isLoading) return;

		const { validate, newObj } = await checkValidate<ILoginFormStore>(
			loginFromStore,
			LOGIN_VALIDATION_SCHEMA
		)

		if (validate) {
			login();
		} else {
			setLoginFormStore(newObj);
		}
	}

    return (
        <form onSubmit={handleSubmit} className={styles.loginForm}>
			<div className={styles.formBody}>
				<div className={styles.inputsWrapper}>
					{INPUTS_ARR.map(input => {
						const { inputName, label } = input;
						const { value, type } = loginFromStore[inputName];
						const withIcon = inputName === LoginInputKeys.PASSWORD_INPUT;

						return (
							<Input<ILoginFormStore>
								key={inputName}
								value={value}
								name={inputName}
								isRequired
								type={type}
								className={styles.loginFormInput}
								labelText={label}
								onChange={handleChangeInput}
								changeTypeFn={changeInputType}
								withErrorBlock
								withPasswordIcon={withIcon}
								error={loginFromStore[inputName].errorMessage}
							/>
						)
					})}
				</div>

				<LoginLinks />
			</div>

            <div className={styles.buttonsBlock}>
				<Button
					className={styles.loginFormButton}
					disabled={isLoading}
					type='submit'
				>
					{
						isLoading
							? 	<Spinner
									size={20}
									borderSize={2}
									color='var(--white)'
								/>
							: 'Войти'
					}
				</Button>
            </div>
          </form>
    )
}